import type { UsageBucket } from "./usage.types";

const COMPACT = new Intl.NumberFormat("en", {
	notation: "compact",
	maximumFractionDigits: 1,
});
const DAY_FMT = new Intl.DateTimeFormat("en", {
	month: "short",
	day: "numeric",
});
const HOUR_FMT = new Intl.DateTimeFormat("en", {
	hour: "2-digit",
	minute: "2-digit",
});

export const formatTokens = (n: number) => COMPACT.format(n);

// Known sources have a "usage.sources" translation key; unrecognized values
// (for example "unknown") are title-cased by the caller for display.
const KNOWN_SOURCES = new Set(["v1", "mcp"]);
export const isKnownSource = (source: string): source is "v1" | "mcp" => KNOWN_SOURCES.has(source);
export const titleCaseSource = (source: string) => source.charAt(0).toUpperCase() + source.slice(1);

export function formatBucket(iso: string, bucket: UsageBucket) {
	const d = new Date(iso);
	return bucket === "hour" ? HOUR_FMT.format(d) : DAY_FMT.format(d);
}
